import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontIcon } from 'react-md';
import { baseUrl } from './../../../services/endpoints';

const TopNavigation = ({ user, onToggleMenu }) => {
  const displayName = (user && (
    (user.first_name && user.last_name)
      ? `${user.first_name} ${user.last_name}`
      : user.first_name || user.name || user.username || user.email
  )) || 'Usuario';
  const showBibliotecas = baseUrl.includes('bkappuninorte');

  return (
    <header style={styles.header}>
      <div style={styles.left}>
        <button
          className="hamburger-btn"
          onClick={onToggleMenu}
          aria-label="Abrir menú"
          style={styles.hamburger}
        >
          <FontIcon style={{ color: 'white', fontSize: 28 }}>menu</FontIcon>
        </button>
        <img src="/images/logo2.png" alt="Autopréstamo" style={styles.logo} />
        <span style={styles.brand}>Autopréstamo</span>
      </div>
      <div style={styles.right}>
        {showBibliotecas && (
          <button
            style={styles.bibliotecasBtn}
            onClick={() => window.open('https://bibliotecas.geniatecnologia.co/', '_blank')}
            aria-label="Abrir Bibliotecas en nueva pestaña"
          >
            <i className="fas fa-book-reader" style={{ fontSize: 13, marginRight: 6 }} />
            <span>Bibliotecas</span>
            <i className="fas fa-external-link-alt" style={{ fontSize: 10, marginLeft: 6, opacity: 0.7 }} />
          </button>
        )}
        <Link to="/profile" style={styles.profileLink}>
          <FontIcon style={styles.userIcon}>account_circle</FontIcon>
          <span style={styles.userName}>{displayName}</span>
        </Link>
      </div>
    </header>
  );
};

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#333',
    padding: '0 24px',
    height: 60,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  hamburger: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: 32,
  },
  brand: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginLeft: 16,
    color: 'white',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  bibliotecasBtn: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.35)',
    borderRadius: 20,
    padding: '6px 14px',
    color: 'white',
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  profileLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    textDecoration: 'none',
    cursor: 'pointer',
  },
  userIcon: {
    color: '#F5A623',
    fontSize: 28,
  },
  userName: {
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
  },
};

const mapStateToProps = state => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(TopNavigation);
